/**
 * Global Imports
*/

import React from 'react';
import { Route, Switch } from 'react-router-dom';

/**
 * Local Imports
*/

import { Dashboard } from '../../Views/Dashboard';
import { Logout } from '../../Views/Logout';
import { UserRouter } from './UserRouter';
import { RoleRouter } from './RoleRouter';
import { PermissionRouter } from './PermissionRouter';
import { AbilityRouter } from './AbilityRouter';

/**
 * Exports
*/

/**
 * 
 */
export function VerifiedRouter(props) {
  return (
    <Switch>
      <Route path='/' exact component={ Dashboard } />
      <Route path='/users' component={ UserRouter } />
      <Route path='/abilities' component={ AbilityRouter } />
      <Route path='/roles' component={ RoleRouter } />
      <Route path='/permissions' component={ PermissionRouter } />
      <Route path='/logout' component={ Logout } />
    </Switch>
  );
}